import React, { Component } from "react";
import { config } from "../../config/general.config";
import { Form, Select } from "antd";

const { Option } = Select;

class SelectFuelSupply extends Component {
  initState = {
    dataOption: config.enum_fuel_supply_system,
  };
  state = { ...this.initState };

  componentDidMount = async () => {
    try {
    } catch (error) {
      this.setState({
        dataOption: [],
      });
    }
  };

  render() {
    return (
      <Form.Item label="Fuel Supply System" name="fuel_supply_system" className="col-lg-12 my-1 py-1">
        <Select style={{ fontSize: "85%", minWidth: "200px" }} placeholder="Select Fuel Supply System" onChange={this.props.onChangeValue} mode={this.props.mode}>
          {this.state.dataOption.map((d, i) => {
            return (
              <Option key={d} value={d}>
                {d}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default SelectFuelSupply;
